import React from 'react';

import { Container, Card, CardContent, Avatar, Box } from '@mui/material';
import LockIcon from '@mui/icons-material/Lock';
import { Outlet } from 'react-router-dom';

const LoginLayout: React.FC = () => {
  return (
    <Container maxWidth='sm' sx={{ marginTop: 5 }}>
      <Card>
        <CardContent>
          <Box sx={{ display: 'flex', justifyContent: 'center' }}>
            <Avatar>
              <LockIcon />
            </Avatar>
          </Box>
          <Outlet />
        </CardContent>
      </Card>
    </Container>
  );
};

export default LoginLayout;
